import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import { api } from '../lib/api';

// Fetch public settings SEKALI per sesi app (module-level cache) — tidak refetch tiap rerender Footer
let settingsPromise = null;
const getPublicSettings = () => {
  if (!settingsPromise) {
    settingsPromise = api.get('/settings/public').then((r) => r.data).catch(() => ({}));
  }
  return settingsPromise;
};

// TikTok tidak tersedia di lucide-react — inline SVG (tanpa dependency baru), fill currentColor
const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SOCIALS = [
  { key: 'social_facebook', label: 'Facebook TokoSipil.id', Icon: Facebook, testid: 'social-facebook' },
  { key: 'social_instagram', label: 'Instagram TokoSipil.id', Icon: Instagram, testid: 'social-instagram' },
  { key: 'social_tiktok', label: 'TikTok TokoSipil.id', Icon: TikTokIcon, testid: 'social-tiktok' },
];

export default function Footer() {
  const [social, setSocial] = useState({});
  useEffect(() => {
    let active = true;
    getPublicSettings().then((d) => { if (active) setSocial(d || {}); });
    return () => { active = false; };
  }, []);

  return (
    <footer className="bg-brand-black text-white mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="mb-4">
              <img src="/logo-footer.webp" alt="TokoSipil.id" className="h-8 w-auto" />
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
              Marketplace produk digital untuk industri konstruksi dan teknik sipil Indonesia. Gambar kerja, RAB, template, dan dokumen teknis dari para praktisi.
            </p>
            <div className="flex items-center gap-3 mt-6" data-testid="footer-social">
              {SOCIALS.filter((s) => (social[s.key] || '').trim()).map(({ key, label, Icon, testid }) => (
                <a key={key} href={social[key].trim()} target="_blank" rel="noopener noreferrer" aria-label={label}
                  data-testid={testid}
                  className="w-9 h-9 flex items-center justify-center border border-zinc-700 text-zinc-400 hover:text-brand-red hover:border-brand-red transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm mb-4 text-zinc-300 uppercase tracking-widest">Tentang</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/tentang" className="hover:text-white transition-colors">Tentang TokoSipil</Link></li>
              <li><Link to="/artikel" className="hover:text-white transition-colors">Artikel</Link></li>
              <li><Link to="/kategori" className="hover:text-white transition-colors">Kategori</Link></li>
              <li><Link to="/jadi-seller" className="hover:text-white transition-colors">Jadi Seller</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm mb-4 text-zinc-300 uppercase tracking-widest">Bantuan</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/pusat-bantuan" className="hover:text-white transition-colors">Pusat Bantuan</Link></li>
              <li><Link to="/cara-berbelanja" className="hover:text-white transition-colors">Cara Berbelanja</Link></li>
              <li><Link to="/cara-berjualan" className="hover:text-white transition-colors">Cara Berjualan</Link></li>
              <li><Link to="/hubungi-kami" className="hover:text-white transition-colors">Hubungi Kami</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm mb-4 text-zinc-300 uppercase tracking-widest">Kebijakan</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/syarat-ketentuan" className="hover:text-white transition-colors">Syarat &amp; Ketentuan</Link></li>
              <li><Link to="/kebijakan-privasi" className="hover:text-white transition-colors">Kebijakan Privasi</Link></li>
              <li><Link to="/kebijakan-refund" className="hover:text-white transition-colors">Kebijakan Refund</Link></li>
              <li><Link to="/lisensi-produk-digital" className="hover:text-white transition-colors">Lisensi Produk Digital</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm mb-4 text-zinc-300 uppercase tracking-widest">Seller</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/jadi-seller" className="hover:text-white transition-colors">Buka Toko</Link></li>
              <li><Link to="/masuk" className="hover:text-white transition-colors">Login Seller</Link></li>
              <li><Link to="/panduan-seller" className="hover:text-white transition-colors">Panduan Seller</Link></li>
              <li><Link to="/komisi-pembayaran" className="hover:text-white transition-colors">Komisi &amp; Pembayaran</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-500">© 2026 TokoSipil.id — Marketplace Produk Digital Konstruksi Indonesia. Seluruh hak cipta dilindungi.</p>
          <p className="text-xs text-zinc-600">Dibuat untuk para engineer Indonesia.</p>
        </div>
      </div>
    </footer>
  );
}
